import { Outlet } from 'react-router-dom';

/**
 * Layout для auth-страниц на стеке фронтендера. Не оборачивает контент
 * в Flatkit-карточку — каждая страница сама управляет полноэкранным
 * layout-ом через Tailwind (min-h-screen, bg-surface-auth-page и т.п.),
 * как принято в mcms-front.
 *
 * legacy GuestLayout удалён вместе с этим файлом (3.6).
 */
export function NewAuthLayout() {
  return <Outlet />;
}
